/* eslint-disable no-underscore-dangle */
import React from 'react'
import BannerShell from 'components/flex/Banner/BannerShell'
import TextShell from 'components/flex/Text/TextShell'
import Form from 'components/flex/Form'
import PostsShell from 'components/flex/Posts/PostsShell'
import Fragment from 'components/flex/Fragment'

import ScrollReveal from 'components/shared/ScrollReveal'

interface FlexContentProps {
  prefix?: string
  fields: any
  location?: any
}

interface FlexerProps {
  [key: string]: any
}

interface ComponentProps {
  fields: any
  location?: any
}

function FlexContentHandler({
  prefix = 'page_Flexcontent',
  fields,
  location = {},
}: FlexContentProps) {
  const flexers: FlexerProps = {
    [`${prefix}_Flex_Banner`]: BannerShell,
    [`${prefix}_Flex_Text`]: TextShell,
    [`${prefix}_Flex_Form`]: Form,
    [`${prefix}_Flex_Posts`]: PostsShell,
    [`${prefix}_Flex_Fragment`]: Fragment,
  }

  if (!fields.flex) {
    return null
  }

  return (
    <>
      {fields.flex.map((section: any, index: number) => {
        if (!section.fieldGroupName || !flexers[section.fieldGroupName]) {
          return null
        }

        const Component = flexers[
          section.fieldGroupName
        ] as React.ComponentType<ComponentProps>

        return (
          <ScrollReveal
            // eslint-disable-next-line react/no-array-index-key
            key={`${location ? location.pathname : 'flex'}-${index}`}
          >
            <Component fields={section} location={location} />
          </ScrollReveal>
        )
      })}
    </>
  )
}

export default FlexContentHandler
